import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ScrollRestoration, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap5';

import Preview from './Preview';

export default function Log({ members, logs }) {
  const navigate = useNavigate();
  const [continueImport, setContinueImport] = useState(false);

  const filteredMembers = members.filter((member) => (
    member['Work Email'] && !(logs && logs.some((log) => log.status === 'error' && log.email === member['Work Email']))
  ));

  if (continueImport) {
    return <Preview members={filteredMembers} />;
  }

  return (
    <div className="content">
      <section>
        <h1 className="mb-3">Import Log</h1>

        <p>
          This log shows the number of records imported and any records that have caused an error during import.
        </p>
      </section>

      <section>
        <table className="table m-0 fw-light">
          <tbody>
            {logs.map((log, index) => (
              <tr key={log.email} className={(log.status === 'error') ? 'table-danger text-danger' : ''}>
                <td>{index + 1}</td>
                <td>{log.email}</td>
                <td>{log.status}</td>
                <td>{log.messages?.join(', ')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <footer className="d-flex d-sm-block justify-content-between">
        <Button
          variant="outline-primary"
          onClick={() => navigate(0)}
        >
          Cancel
        </Button>

        <Button
          onClick={() => { setContinueImport(true); }}
          disabled={filteredMembers.length === 0}
        >
          Continue
        </Button>
      </footer>

      <ScrollRestoration />
    </div>
  );
}

Log.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
  logs: PropTypes.arrayOf(PropTypes.object).isRequired,
};
